import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface ICreditEligibilityReportState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: ICreditEligibilityReportState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: ICreditEligibilityReportState = initialState,
  action: ActionWithPayload<ICreditEligibilityReportState>
) => {
  switch (action.type) {
    case actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_START:
      return {...state, loading: true}
    case actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
